import { ProprietarySvgIcon } from './proprietary-icon.model';


export const proprietaryIcons: ProprietarySvgIcon[] = [
  { label: 'lift'},
  { label: 'logs'},
  { label: 'package'},
  { label: 'settings'},
];
